import { render, staticRenderFns } from "./LinkRR.vue?vue&type=template&id=4a994b5c"
import script from "./LinkRR.vue?vue&type=script&lang=js"
export * from "./LinkRR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports